import { useState } from "react";
import { toast } from "sonner";
import { Key } from "@phosphor-icons/react";
import { api, setSecret } from "@/lib/api";

export function SecretGate({ onSuccess, title = "Area Admin" }) {
    const [phrase, setPhrase] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/admin/verify", { phrase });
            setSecret(phrase);
            onSuccess();
        } catch {
            toast.error("Frasa rahasia salah");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-6" data-testid="admin-gate">
            <form onSubmit={submit} className="w-full max-w-sm fade-up">
                <div className="flex justify-center mb-8">
                    <img src="/logo.png" alt="INERRE interior" className="h-16 object-contain" data-testid="gate-logo" />
                </div>
                <p className="text-center text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground mb-6">
                    {title}
                </p>
                <div className="flex items-center border border-border bg-white focus-within:border-primary transition-colors">
                    <Key size={18} className="ml-3 text-muted-foreground" weight="light" />
                    <input
                        data-testid="admin-secret-input"
                        type="password"
                        value={phrase}
                        onChange={(e) => setPhrase(e.target.value)}
                        placeholder="Masukkan Frasa Rahasia"
                        className="w-full px-3 py-3 bg-transparent outline-none text-sm"
                        autoFocus
                    />
                </div>
                <button
                    data-testid="admin-gate-submit"
                    type="submit"
                    disabled={loading || !phrase}
                    className="mt-4 w-full bg-primary text-primary-foreground py-3 text-sm tracking-wide font-medium hover:bg-[#9c4a2a] transition-colors disabled:opacity-50"
                >
                    {loading ? "Memeriksa..." : "Masuk"}
                </button>
            </form>
        </div>
    );
}
